import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminIndustry = (state: ApplicationRootState) =>
    state.admin.industry || initialState;

export const selectIndustryList = createSelector(
    selectAdminIndustry,
    (state) => state.list
);

export const selectIndustryListOptions = createSelector(
    selectAdminIndustry,
    (state) => {
        return (
            state.list.data?.map((industry) => ({
                label: industry.name,
                value: industry.id,
            })) ?? []
        );
    }
);
